import { useState } from "react";

const useUserTransmissionProgressReport = () => {
  const [showUserTransmissionReportModal, setShowUserTransmissionReportModal] =
    useState(false);

  const closeModal = () => setShowUserTransmissionReportModal(false);

  const openModal = () => setShowUserTransmissionReportModal(true);

  return {
    showUserTransmissionReportModal,
    openModal,
    closeModal,
  };
};

export default useUserTransmissionProgressReport;
